const fallbackLoginPath = '/sign_in'

let isRedirectingToLogin = false

function loginUrlFromResponse(response) {
  // Some Rails controllers include the canonical login URL in 401 JSON responses.
  // API controllers do not always include it, so keep a same-origin fallback.
  const responseLoginUrl = response?.data?.login_url
  if (responseLoginUrl) return responseLoginUrl

  return `${window.location.origin}${fallbackLoginPath}`
}

// Skip redirect handling when the browser is already on the login page.
function isLoginPage() {
  return window.location.pathname === fallbackLoginPath
}

// Skip redirect handling for api requests that target the login page itself.
function isLoginRequest(requestUrl) {
  if (!requestUrl) return false

  try {
    const url = new URL(requestUrl, window.location.origin)
    return url.pathname === fallbackLoginPath
  } catch (_) {
    return false
  }
}

function shouldHandleUnauthorizedResponse(error) {
  const responseStatus = error?.response?.status
  const requestUrl = error?.config?.url

  // Only redirect for unauthorized API responses outside the login flow.
  return responseStatus === 401 && !isLoginPage() && !isLoginRequest(requestUrl)
}

export function installSessionTimeoutInterceptor(axiosInstance) {
  if (!axiosInstance) return
  if (axiosInstance.__fastVisaSessionTimeoutInterceptorInstalled) return

  axiosInstance.__fastVisaSessionTimeoutInterceptorInstalled = true

  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (shouldHandleUnauthorizedResponse(error) && !isRedirectingToLogin) {
        const loginUrl = loginUrlFromResponse(error.response)
        isRedirectingToLogin = true
        window.location.assign(loginUrl)
      }

      // Preserve existing per-request catch handlers after starting the redirect.
      return Promise.reject(error)
    }
  )
}
